const isValidNumber = value => {
  value = Number(value);
  if (isNaN(value) || value <= 0 || !value || value < 100000) {
    return false;
  }

  return true;
};

function animateValue(obj, start, end, duration) {
  let startTimestamp = null;
  const step = timestamp => {
    if (!startTimestamp) startTimestamp = timestamp;
    const progress = Math.min((timestamp - startTimestamp) / duration, 1);
    obj.innerHTML = Math.floor(progress * (end - start) + start).toLocaleString(
      "pt-BR"
    );
    if (progress < 1) {
      window.requestAnimationFrame(step);
    }
  };
  window.requestAnimationFrame(step);
}

function isElementInViewport(el) {
  var rect = el.getBoundingClientRect();

  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

function onVisibilityChange(el, callback) {
  let oldVisible;

  return function() {
    var visible = isElementInViewport(el);
    if (visible != oldVisible) {
      oldVisible = visible;
      if (typeof callback == "function") {
        callback(visible);
      }
    }
  };
}

(function() {
  const container = document.querySelector(".record-count");

  if (!container) {
    return;
  }

  const title = container.querySelector(".record-count-title");

  const totalAppointments = container.querySelector(
    ".record-count-total-appointments"
  );
  const totalPatients = container.querySelector(".record-count-total-patients");
  const messagesExchanged = container.querySelector(
    ".record-count-total-messages-exchanged"
  );

  let data = null;
  let oldData = null;

  const showNumbers = () => {
    if (data === null) {
      return;
    }

    if (
      !isValidNumber(data.total_appointments) ||
      !isValidNumber(data.total_messages_exchanged) ||
      !isValidNumber(data.total_patients)
    ) {
      container.classList.add("tw-hidden");
      return;
    }

    if (!isElementInViewport(totalPatients)) {
      return;
    }

    if (data.total_appointments != oldData?.total_appointments) {
      animateValue(
        totalAppointments,
        oldData?.total_appointments ? oldData?.total_appointments : 0,
        data.total_appointments,
        1000
      );
    }

    if (data.total_patients != oldData?.total_patients) {
      animateValue(
        totalPatients,
        oldData?.total_patients ? oldData?.total_patients : 0,
        data.total_patients,
        1000
      );
    }

    if (data.total_messages_exchanged != oldData?.total_messages_exchanged) {
      animateValue(
        messagesExchanged,
        oldData?.total_messages_exchanged
          ? oldData?.total_messages_exchanged
          : 0,
        data.total_messages_exchanged,
        1000
      );
    }
  };

  const getData = () => {
    fetch("/record-counter")
      .then(response => {
        if (!response.ok) {
          container.classList.add("tw-hidden");
          return;
        }

        response
          .json()
          .then(responseData => {
            oldData = JSON.parse(JSON.stringify(data));
            data = responseData;
            showNumbers();
          })
          .catch(error => {
            console.error(error);
            container.classList.add("tw-hidden");
          });
      })
      .catch(error => {
        console.error(error);
        container.classList.add("tw-hidden");
      });
  };

  getData();

  let interval = null;

  var handler = onVisibilityChange(totalPatients, function(visible) {
    if (!visible && interval) {
      clearInterval(interval);
      interval = null;
    }

    if (visible && !interval) {
      getData();
      interval = setInterval(getData, 5000);
    }

    if (visible) {
      showNumbers();
    }
  });

  addEventListener("DOMContentLoaded", handler, false);
  addEventListener("load", handler, false);
  addEventListener("scroll", handler, false);
})();
